import { cx } from '@emotion/css';
import { components, ValueContainerProps } from 'react-select';
import { PhoenixIcon } from '../../../phoenix-icon/phoenix-icon';

export const DropdownValueContainer = ({ children, ...props }: ValueContainerProps) => {
  return (
    <components.ValueContainer
      {...props}
      className={cx('grid gap-2 border-none', props?.selectProps?.prefixIcon && '!pl-10')}
      innerProps={
        {
          ...props.innerProps,
          'data-testid': 'dropdown-value',
        } as ValueContainerProps['innerProps']
      }
    >
      {props.selectProps?.prefixIcon && (
        <div className="absolute bottom-0 left-0 top-0 flex w-12 items-center justify-center">
          <PhoenixIcon icon={props.selectProps?.prefixIcon} />
        </div>
      )}
      {children}
    </components.ValueContainer>
  );
};
